import { useGetSiteStatus } from '@legacy/apis/indexAPI';
import { Chip } from '@mui/material';

export const LegacySiteStatus = () => {
  const { siteStatus } = useGetSiteStatus();

  return (
    <>
      {siteStatus && siteStatus === 'Sandbox' ? (
        <Chip label={siteStatus} color="warning" />
      ) : null}

      {siteStatus && siteStatus === 'Learning' ? (
        <Chip label={siteStatus} color="success" />
      ) : null}

      {siteStatus && siteStatus === 'Internal' ? (
        <Chip label={siteStatus} color="secondary" />
      ) : null}
    </>
  );
};
